type Scale = ((value: number) => number) & { domain: () => number[] };
type AxisMap = Record<string, { scale?: Scale }>;

type YourAgeLabelProps = {
  // Injected by recharts <Customized />.
  xAxisMap?: AxisMap;
  yAxisMap?: AxisMap;
};

// Caption pinned to the end of the y=x diagonal, rotated to match the line's
// on-screen angle (which changes with the zoom). Rendered via <Customized> so
// it can read the axis scales.
export default function YourAgeLabel({ xAxisMap, yAxisMap }: YourAgeLabelProps) {
  const xScale = xAxisMap && Object.values(xAxisMap)[0]?.scale;
  const yScale = yAxisMap && Object.values(yAxisMap)[0]?.scale;
  if (!xScale || !yScale) return null;

  // The diagonal runs from (xStart, xStart) to (xEnd, xEnd) in data space.
  const [xStart, xEnd] = xScale.domain();
  const x1 = xScale(xStart);
  const y1 = yScale(xStart);
  const x2 = xScale(xEnd);
  const y2 = yScale(xEnd);
  const angle = (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI;

  return (
    <text
      x={x2}
      y={y2}
      dx={-4}
      dy={-4}
      textAnchor='end'
      transform={`rotate(${angle}, ${x2}, ${y2})`}
      fontSize={11}
      fill='var(--cold-grey-900)'
    >
      your age
    </text>
  );
}
